import { Colors } from '../../../utils/resources/colors';
import { UIComponentCSSStyle, UIComponentCSSStyleImpl } from '../../toolkit/uicomponentcss';

export interface NameTunesCSSStyle extends UIComponentCSSStyle
{
    getTitleCSSStyle():object;
    getInnerWrapperCSSStyle():object;
    getPaginationCSSStyle(): object;
}

export class NameTunesCSSStyleImpl extends UIComponentCSSStyleImpl implements NameTunesCSSStyle
{
    getWrapperCSSStyle(): object
    {
        return {
            width: "100%",
            justifyContent:'center',
            display:'flex',
            // paddingTop:"25px",
            flexFlow:'row',
            textAlign: "center",
            alignItems:'center'

        };
    }
    getPaginationCSSStyle(): object 
    {
        return {
            height: "50px",
            width: "100%",
            // marginTop: "50px",
            
        };
    }
    getInnerWrapperCSSStyle():object
    {
        return{
            width:'100%',
            height:'100%',
            paddingTop: "20px",
            justifyContent:'center',
        };
    }
    getTitleCSSStyle(): object 
    {
        return {
            display: "flex",
            textAlign: "center",
            justifyContent: 'flex-start',
            height: "30px",
            fontWeight: 800,
            letterSpacing: 0,
            textShadow: "0 1px 1px 0 rgba(0,0,0,0.18)",
            color: this.getResources().getColor(Colors.color_6),
            fontFamily: this.getResources().getFontFamily(),
            lineHeight: "30px",
            marginLeft: '0px',
        };
    } 
}



// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/components/nametunes/nametunescss.tsx